// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard, CashierGuard, AdminGuard, ModuleGuard } from './core/auth';
import {ENUM} from './core/enum/enum';

const routes: Routes = [
	{path: 'auth', loadChildren: () => import('../app/views/pages/auth/auth.module').then(m => m.AuthModule)},
	{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('../app/views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN, ENUM.roles.AIRPORT]
				}
			},
			{
				path: 'mail',
				loadChildren: () => import('../app/views/pages/apps/mail/mail.module').then(m => m.MailModule),
				canActivate: [AdminGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN]
				}
			},
			{
				path: 'company-management',
				loadChildren: () => import('../app/views/pages/admin/company-management/company-management.module').then(m => m.CompanyManagementModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN,ENUM.roles.OPERATION, ENUM.roles.FINANCIAL]
				}
			},
			{
				path: 'area-management',
				loadChildren: () => import('../app/views/pages/admin/area-management/area-management.module').then(m => m.AreaManagementModule),
				canActivate: [AdminGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN]
				}
			},
			{
				path: 'queue-management',
				loadChildren: () => import('../app/views/pages/admin/queue-management/queue-management.module').then(m => m.QueueManagementModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN,ENUM.roles.OPERATION,ENUM.roles.AIRPORT]
				}
			},
			{
				path: 'reports',
				loadChildren: () => import('../app/views/pages/admin/reports/reports.module').then(m => m.ReportsModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN,ENUM.roles.AIRPORT]
				}
			},
			{
				path: 'lookup-management',
				loadChildren: () => import('../app/views/pages/admin/lookup-management/lookup-management.module').then(m => m.LookupManagementModule),
				canActivate: [AdminGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN]
				}
			},
			{
				path: 'live-queue-statistics',
				loadChildren: () => import('../app/views/pages/admin/live-queue-statistics/live-queue-statistics.module').then(m => m.LiveQueueStatisticsModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN,ENUM.roles.FINANCIAL, ENUM.roles.AIRPORT, ENUM.roles.OPERATION]
				}
			},
			{
				path: 'cashier-management',
				loadChildren: () => import('../app/views/pages/admin/cashier-management/cashier-management.module').then(m => m.CashierManagementModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN,ENUM.roles.FINANCIAL, ENUM.roles.AIRPORT]
				}
			},
			{
				path: 'cashier',
				loadChildren: () => import('../app/views/pages/cashier/cashier.module').then(m => m.CashierModule),
				canActivate: [CashierGuard],
				data:{
					moduleName: [ENUM.roles.CASHIER]
				}
			},
			{
				path: 'driver',
				loadChildren: () => import('../app/views/pages/driver/driver.module').then(m => m.DriverModule),
				canActivate: [ModuleGuard],
				data:{
					moduleName: [ENUM.roles.COMPANY_DRIVER]
				}
			},
			{
				path: 'user-management',
				loadChildren: () => import('../app/views/pages/user-management/user-management.module').then(m => m.UserManagementModule),
				canActivate: [AdminGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN]
				}
			},
			{
				path: 'builder',
				loadChildren: () => import('../app/views/theme/content/builder/builder.module').then(m => m.BuilderModule),
				canActivate: [AdminGuard],
				data:{
					moduleName: [ENUM.roles.ADMIN]
				}
			},
			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					'type': 'error-v6',
					'code': 403,
					'title': '403... Access forbidden',
					'desc': 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
				}
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'dashboard', pathMatch: 'full'},
			{path: '**', redirectTo: 'dashboard', pathMatch: 'full'}
		]
	},

	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
